<div class="confirm-modal modal-surface">
  <div class="confirm-icon">
    <span class="material-symbols-rounded">{{ data.icon || 'help' }}</span>
  </div>
  <h2>{{ data.title || (translationKeys.SHARED.MODALS.CONFIRM.TITLE | translate) }}</h2>
  <!-- innerHTML allows simple formatting (e.g. <b>) in the messages; Angular sanitizes it -->
  <p [innerHTML]="data.message || (translationKeys.SHARED.MODALS.CONFIRM.MESSAGE | translate)"></p>
  <div class="actions">
    <button type="button" class="btn btn-filled" [mat-dialog-close]="true">
      {{ translationKeys.BUTTONS.CONFIRM | translate }}
    </button>
    <button type="button" class="btn btn-outline" [mat-dialog-close]="false">
      {{ translationKeys.BUTTONS.CLOSE | translate }}
    </button>
  </div>
</div>
